(() => {
  const HG_FLAT = window.HG_FLAT || [];
  const REDS = window.REDS || [];

  const manuSel = document.getElementById('manufacturer');
  const modelSel = document.getElementById('model');
  const resultsDiv = document.getElementById('results');

  if (!manuSel || !modelSel || !resultsDiv) return;

  const norm = s => (s || '').toString().trim().toLowerCase();

  function parseFootprintItem(s) {
    if (typeof s !== 'string') return { name: '', note: '' };
    const i = s.indexOf(':');
    if (i === -1) return { name: s.trim(), note: '' };
    return { name: s.slice(0, i).trim(), note: s.slice(i + 1).trim() };
  }

  function renderNoteHTML(note) {
    if (!note) return '';
    return note
      .replace(/\[([^|\]]*)\|([^\]]+)\]/g, (match, text, url) => {
        const label = (text || '').trim() || 'View';
        const safeUrl = (url || '').replace(/"/g, '&quot;');
        return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${label}</a>`;
      })
      .replace(/\[([^\|\]]+)\]/g, (match, maybeUrl) => {
        if (/^https?:\/\//i.test((maybeUrl || '').trim())) {
          const safeUrl = maybeUrl.trim().replace(/"/g, '&quot;');
          return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">View</a>`;
        }
        return match;
      });
  }

  function moneyFromCents(cents) {
    const n = Number(cents);
    if (!isFinite(n)) return '';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n / 100);
  }

  function escapeHTML(str) {
    return (str || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderGunSectionHTML(gun) {
  const img = gun.image || '';
  const content = gun.content_html || '';

  if (!img && !content) return '';

  return `
    <div class="optic-gun">
      <div class="optic-gun__text">
        <h3>${gun.manufacturer} ${gun.model}</h3>
        ${content}
      </div>
      ${img ? `
        <div class="optic-gun__img">
          <img src="${img}" alt="">
        </div>
      ` : ''}
    </div>
  `;
}


  // ✅ your exact data shape
  function getProductData(m) {
    const p = m && m.PRODUCT ? m.PRODUCT : null;

    // image: product featured_image or first image, fallback to first variant featured_image
    const img =
      (p && p.featured_image) ||
      (p && Array.isArray(p.images) && p.images[0]) ||
      (p && Array.isArray(p.variants) && p.variants[0] && p.variants[0].featured_image && p.variants[0].featured_image.src) ||
      '';

    const url = p && p.handle ? `/products/${p.handle}` : (m.URL || '');

    const price = p ? p.price : null;
    const compareAt = p ? p.compare_at_price : null;

    // availability
    const available = p ? !!p.available : true;

    // optional badge text (you can map something here if you have it elsewhere)
    const badge = m.Badge || m.badge || '';

    // brand display
    const brand = (m.Brand || (p && p.vendor) || 'Other').toString().trim() || 'Other';

    return { img, url, price, compareAt, available, badge, brand };
  }

  // Manufacturer list
  const MANUS = Array.from(new Set(HG_FLAT.map(h => h.manufacturer).filter(Boolean)))
    .sort((a, b) => a.localeCompare(b));

  manuSel.innerHTML =
    '<option value=""></option>' +
    MANUS.map(m => `<option value="${m}">${m}</option>`).join('');

  manuSel.addEventListener('change', () => {
    const manu = manuSel.value;
    const models = HG_FLAT.filter(h => h.manufacturer === manu).map(h => h.model);
    const unique = Array.from(new Set(models)).filter(Boolean).sort((a, b) => a.localeCompare(b));

    modelSel.innerHTML =
      '<option value=""></option>' +
      unique.map(m => `<option value="${m}">${m}</option>`).join('');

    modelSel.disabled = unique.length === 0;
    resultsDiv.innerHTML = '';
  });

  modelSel.addEventListener('change', () => {
    const manu = manuSel.value;
    const model = modelSel.value;

    const gun = HG_FLAT.find(h => h.manufacturer === manu && h.model === model);
    if (!gun) { resultsDiv.innerHTML = ''; return; }

    const fpsRaw = Array.isArray(gun.footprints) ? gun.footprints : [];
    const fps = fpsRaw.map(parseFootprintItem).filter(fp => fp.name);

    // matches
    const matches = REDS.filter(r => {
      const opticFps = Array.isArray(r._FootprintsParsed) ? r._FootprintsParsed : [];
      const opticSet = new Set(opticFps.map(norm));
      return fps.some(fp => opticSet.has(norm(fp.name)));
    });

   
    // group by Brand
    const grouped = matches.reduce((acc, m) => {
      const { brand } = getProductData(m);
      (acc[brand] ||= []).push(m);
      return acc;
    }, {});

    const TOP = Array.isArray(window.top_brands) ? window.top_brands : [];

    // // sort brands by count desc then alpha
    // const brands = Object.keys(grouped).sort((a, b) => {
    //   const d = grouped[b].length - grouped[a].length;
    //   return d !== 0 ? d : a.localeCompare(b, undefined, { sensitivity: 'base' });
    // });

    // sort all brands:
    // - first: in TOP, in TOP's order
    // - then: not in TOP, by count desc then alpha
    const brands = Object.keys(grouped).sort((a, b) => {
      const ia = TOP.indexOf(a);
      const ib = TOP.indexOf(b);

      const aInTop = ia !== -1;
      const bInTop = ib !== -1;

      if (aInTop && bInTop) return ia - ib;      // both in TOP → TOP order
      if (aInTop) return -1;                      // only a in TOP → a first
      if (bInTop) return 1;                       // only b in TOP → b first

      // neither in TOP → your old logic
      const d = grouped[b].length - grouped[a].length;
      return d !== 0 ? d : a.localeCompare(b, undefined, { sensitivity: "base" });
    });

    const groupedHTML = brands.map((brand, idx) => {
      const items = grouped[brand];

      const cardsHTML = items.map(m => {
        const opticFps = Array.isArray(m._FootprintsParsed) ? m._FootprintsParsed : [];
        const opticSet = new Set(opticFps.map(norm));

        const noteBlocks = fps
          .filter(fp => opticSet.has(norm(fp.name)))
          .map(fp =>
            fp.note
              ? `<div class="optic-note"><svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16671 12.5V9.16665M9.16671 5.83331H9.17504M17.5 9.16665C17.5 13.769 13.7691 17.5 9.16671 17.5C4.56433 17.5 0.833374 13.769 0.833374 9.16665C0.833374 4.56427 4.56433 0.833313 9.16671 0.833313C13.7691 0.833313 17.5 4.56427 17.5 9.16665Z" stroke="#E18C1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/></svg>${renderNoteHTML(fp.note)}</div>`
              : ''
          ).join('');

        const pd = getProductData(m);

        const badgeHTML = pd.badge ? `<div class="optic-badge">${pd.badge}</div>` : '';

        const priceHTML = (pd.price != null)
          ? `<div class="optic-price">
               <strong>${moneyFromCents(pd.price)}</strong>
               ${pd.compareAt ? `<span class="optic-compare">${moneyFromCents(pd.compareAt)}</span>` : ''}
             </div>`
          : '';

        const availHTML = pd.available
          ? ''
          : `<div class="optic-avail">Out of stock</div>`;

        return `
          <div class="optic-row">
            ${pd.img ? `<img class="optic-img desktop-img" src="${pd.img}" alt="">` : `<div class="optic-img placeholder desktop-img"></div>`}

            <div class="optic-main">
              <div class="optic-top-row">
                ${pd.img ? `<img class="optic-img mobile-img" src="${pd.img}" alt="">` : `<div class="optic-img placeholder mobile-img"></div>`}
                <div>
                  <div class="optic-title">${m.Title || ''}</div>
                  <div class="optic-sub">Footprint : <strong>${opticFps.join(', ') || '-'}</strong></div>
                  ${badgeHTML}
                  ${noteBlocks}
                </div>
              </div>
              <div class="optic-bottom-row">
                 <div>
                    ${priceHTML}
                    ${availHTML}
                </div>
                <div class="optic-actions">
                ${pd.url ? `<a class="optic-btn" href="${pd.url}" target="_blank" rel="noopener">View Product <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 8H15M15 8L8 1M15 8L8 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></a>` : ''}
                </div>
              </div>
            </div>

            
          </div>
        `;
      }).join('');

      return `
        <div class="brand-accordion">
          <button class="brand-header" type="button" aria-expanded="false" data-brand="${idx}">
            <span class="brand-toggle"></span>
            <span class="brand-name">${brand}</span>
            <span class="brand-count">${items.length} Red Dots</span>
          </button>
          <div class="brand-body" id="brand-${idx}">
            ${cardsHTML}
          </div>
        </div>
      `;
    }).join('');

    const availableNames = fps.map(fp => fp.name).join(', ');
    const gunSectionHTML = renderGunSectionHTML(gun);

    resultsDiv.innerHTML = `
      ${gunSectionHTML}
      <div class="optic-heading">
        <div>Available Footprints: <strong>${availableNames || '-'}</strong></div>
        <div>Available Red Dots: <strong>${matches.length}</strong></div>
      </div>
      ${matches.length ? groupedHTML : '<div class="optic-empty">No matching optics for this footprint.</div>'}
    `;

    // accordion toggles
    resultsDiv.querySelectorAll('.brand-header').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.brand;
        const body = resultsDiv.querySelector(`#brand-${id}`);
        const toggle = btn.querySelector('.brand-toggle');

        const open = body.classList.toggle('open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.classList.toggle('open');
        //toggle.textContent = open ? '−' : '+';
      });
    });

    // open first by default
    //resultsDiv.querySelector('.brand-header')?.click();
  });
})();
